import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export interface DeletePlaygroundSessionChatMessageResponseI {
  success: boolean;
  message_id: string;
  deleted_count: number;
}

export interface DeletePlaygroundSessionChatMessageParamsI {
  workspaceId: number;
  sessionId: string;
  messageId: string;
  variableSetIndex: number;
}

export const useAPIDeletePlaygroundSessionChatMessage = (
  userToken: string,
  options?: UseMutationOptions<
    DeletePlaygroundSessionChatMessageResponseI,
    Error,
    DeletePlaygroundSessionChatMessageParamsI
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    DeletePlaygroundSessionChatMessageResponseI,
    Error,
    DeletePlaygroundSessionChatMessageParamsI
  >(
    variables => {
      const baseUrl = ENDPOINTS.playground_session_chat_message(
        variables.workspaceId,
        variables.sessionId,
        variables.messageId,
      );

      const url = new URL(baseUrl);
      url.searchParams.set("variable_set_index", String(variables.variableSetIndex));

      return fetch(url, {
        method: "DELETE",
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          "playground-session-chat-messages",
          variables.workspaceId,
          variables.sessionId,
        ]);
      },
      ...options,
    },
  );
};
